// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vision-illustration{height:30vh;background:grey;margin:32px 0}", ""]);
// Exports
module.exports = exports;
